<div id="page">
    <div id="main" class="m_webPages"  style="margin-top: 45px;">  
        <div class="row">
            <div class="col-md-9">
                <app-component-holder><app-home-announcements></app-home-announcements></app-component-holder>      
                <!-- <app-tripplanner-maps></app-tripplanner-maps> -->
                <ng-container
                    *ngIf="behaviourSubjectService._isUserLoginBS | async"
                >
                    <app-component-holder><favorite-cards></favorite-cards></app-component-holder>
                    <!-- <app-cards></app-cards>
                    <app-card-info></app-card-info> -->
                </ng-container>
                <app-component-holder><app-home-buttons></app-home-buttons></app-component-holder>    
            </div>
            <div class="col-md-3 homeSideBar"> 
                <!-- <app-search-text></app-search-text> -->
                <app-component-holder><router-outlet name="account"></router-outlet></app-component-holder>           
            </div>
        </div>
    </div>
</div>
